import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPrefix } from "features/Application/slices/models";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import usersDataService from "features/Application/services/dataServices/usersDataService";
import { AxiosError } from "axios";
import type { FlowPriorityModal } from "../../types/performance";

export const usersCountByFlowStatusApi = createApi({
  reducerPath: getPrefix({
    namespace: ReducerNamespaceTypes.Flows,
    entity: ReducerEntityPrefixTypes.Users,
    name: "api",
  }),
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  endpoints: (builder) => ({
    getCount: builder.query<number, { flowInfos: FlowPriorityModal[]; statuses: number[] }>({
      queryFn: async (data) => {
        if (data.statuses.length === 0 || data.flowInfos.length === 0) {
          return { data: 0 };
        }
        const requests: Record<number, number[]> = {};

        for (const flowInfo of data.flowInfos) {
          if (!requests[flowInfo.FlowPriority]) {
            requests[flowInfo.FlowPriority] = [];
          }
          requests[flowInfo.FlowPriority].push(flowInfo.FlowId);
        }

        try {
          const promises = Object.entries(requests).map(([priority, flowIds]) =>
            usersDataService.getNotifyUsersCount(flowIds, data.statuses, [Number(priority)]),
          );
          const res = await Promise.all(promises);
          const totalCount = res.reduce((acc, curr) => acc + curr.data.TotalUsers, 0);
          return { data: totalCount };
        } catch (error: unknown) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: error instanceof AxiosError ? error.message : "An unknown error occurred",
              data: error,
            },
          };
        }
      },
    }),
  }),
});

export const { useGetCountQuery } = usersCountByFlowStatusApi;
